<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    font-family: '微软雅黑', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  /* Reset CSS */

  body,
  div,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pre,
  code,
  form,
  fieldset,
  legend,
  input,
  textarea,
  p,
  blockquote,
  th,
  td,
  span,
  a {
    margin: 0;
    /* 清除所有元素的外边距 */
    padding: 0;
    /* 清除所有元素的内边距 */
    font-size: inherit;
    /* 字体大小继承自父元素 */
    font-weight: normal;
    /* 取消加粗效果 */
    line-height: normal;
    /* 取消行高效果 */
    color: inherit;
    /* 文本颜色继承自父元素 */
    vertical-align: baseline;
    /* 默认基线对齐 */
  }

  a {
    text-decoration: none;
    /* 去除超链接下划线 */
    cursor: pointer;
    /* 光标显示为手指形状 */
  }

  img {
    border: 0;
    /* 图片没有边框 */
  }

  .bannerStyle img {
    width: 100%;
    display: block;
  }

  ul,
  ol {
    list-style: none;
    /* 列表无序/有序项前面不添加任何符号 */
  }

  table {
    border-collapse: collapse;
    /* 合并单元格边框 */
  }

  input[type="text"],
  input[type="password"] {
    outline: none;
    /* 输入框获得焦点时不显示边框 */
  }

  button {
    background: none;
    /* 按钮背景为空白 */
    border: none;
    /* 按钮边框为空白 */
    cursor: pointer;
    /* 光标显示为手指形状 */
  }

  img {
    border: 0;
    margin: 0;
    padding: 0;
  }

  .floatRight {
    float: right;
  }

  .floatLeft {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue